import type { Consignee } from 'graphql-models';
import type { Factory } from './helpers';

const MOCK_CONSIGNEE: Consignee = {
  id: '1',
  address: 'Rue de la Gare 1',
  city: 'Paris',
  country: 'France',
  name: 'Mon Signee',
  zip: '2020',
};

export const consigneeFactory: Factory<Consignee> = (overrides) => ({
  ...MOCK_CONSIGNEE,
  ...overrides,
});
